import React from "react";
import { Minus, Plus } from "lucide-react";

const QuantityStepper = ({ value, onChange, disabled, testId, max }) => {
  const atMax = typeof max === "number" && value >= max;
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        aria-label="Decrease"
        data-testid={testId ? `${testId}-decrease` : undefined}
        disabled={disabled || value === 0}
        onClick={() => onChange(Math.max(0, value - 1))}
        className="w-9 h-9 rounded-full border-2 border-[#9b3d0a] text-[#9b3d0a] flex items-center justify-center transition-colors duration-200 enabled:hover:bg-[#9b3d0a] enabled:hover:text-[#f2e5de] disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <Minus size={16} />
      </button>
      <span className="w-6 text-center font-semibold text-[#1e231f] tabular-nums">
        {value}
      </span>
      <button
        type="button"
        aria-label="Increase"
        data-testid={testId ? `${testId}-increase` : undefined}
        disabled={disabled || atMax}
        onClick={() =>
          onChange(typeof max === "number" ? Math.min(max, value + 1) : value + 1)
        }
        className="w-9 h-9 rounded-full border-2 border-[#9b3d0a] text-[#9b3d0a] flex items-center justify-center transition-colors duration-200 enabled:hover:bg-[#9b3d0a] enabled:hover:text-[#f2e5de] disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <Plus size={16} />
      </button>
    </div>
  );
};

export default QuantityStepper;
